import list from 'src/modules/search/list/searchListReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
});
